import React from 'react';
import styles from '../Operations.module.css';
import KpiFocusArea from '../../../../components/kpifocusarea';
interface MOPCComponent extends React.FC {
  title?: string;
  kpiHyperlink?: string;
  actionTitle?: string;
  actionContent?: React.FC;
  actionDrawerWidth?: number;
}

/**
 * MOPC - Minimum Order Point Acceptance
 * KPI information component
 */
const MOPC: MOPCComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>Metric Description</div>

      <div className={styles.sectionContent}>
        Minimum Order Points are established to not only keep you In Stock, but to keep you In Stock
        with the right quantities.
        <br /><br />
        Annually the following SKUs are researched to ensure sufficient quantities are available to
        make the sale:
      </div>

      <div className={styles.sectionContent}>
        <ul>
          <li style={{ marginBottom: '1em' }}>
            Volume items are usually purchased in larger quantities and tend to be consumable.
            Examples of volume SKUs are light bulbs, power saw blades, coffee filters, air fresheners,
            vacuum bags, and washers.
          </li>
          <li style={{ marginBottom: '1em' }}>
            Project items are SKUs generally purchased in quantities greater than one to complete a
            project. Examples of project SKUs are cabinet knobs, casters, paint, caulk, hinges, door
            locks, and fittings.
          </li>
          <li style={{ marginBottom: '1em' }}>
            Display items are generally associated with high retails where an item is kept out of the box for demonstration purposes. The phrase &quot;one to show and one to go&quot; best describes these items. Examples of display SKUs are power tools, small appliances, lighting fixtures, and vacuums. For a SKU to appear on this list they are not meeting or exceeding the Ace Suggested Minimum Order Point.
          </li>
        </ul>
      </div>

      <div className={styles.sectionTitle}>Supporting Details</div>

      <div className={styles.sectionContent}>
        <table style={{ borderCollapse: 'collapse', border: '1px solid #ccc' }}>
          <thead>
            <tr>
              <th scope="col" style={{ padding: '8px 12px', border: '1px solid #ccc', color: '#4a4a4a', fontWeight: 'bold', textAlign: 'left' }}>2025 MOP SKU Performance</th>
              <th scope="col" style={{ padding: '8px 12px', border: '1px solid #ccc', color: '#4a4a4a', fontWeight: 'bold', textAlign: 'left' }}>Avg Sales</th>
              <th scope="col" style={{ padding: '8px 12px', border: '1px solid #ccc', color: '#4a4a4a', fontWeight: 'bold', textAlign: 'left' }}>Avg GP$</th>
              <th scope="col" style={{ padding: '8px 12px', border: '1px solid #ccc', color: '#4a4a4a', fontWeight: 'bold', textAlign: 'left' }}>Avg Units</th>
              <th scope="col" style={{ padding: '8px 12px', border: '1px solid #ccc', color: '#4a4a4a', fontWeight: 'bold', textAlign: 'left' }}>Avg Trans</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ backgroundColor: '#f0f0f0' }}>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc' }}>Above Goal (&gt;80% Adoption)</td>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc' }}>$175,769</td>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc' }}>$88,052</td>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc' }}>23,007</td>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc' }}>11,071</td>
            </tr>
            <tr>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc' }}>Less than 50%</td>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc' }}>$113,698</td>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc' }}>$57,020</td>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc' }}>15,184</td>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc' }}>7,177</td>
            </tr>
            <tr style={{ backgroundColor: '#f0f0f0' }}>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc' }}></td>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc', fontWeight: 'bold' }}>54.6%</td>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc', fontWeight: 'bold' }}>54.4%</td>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc', fontWeight: 'bold' }}>51.5%</td>
              <td style={{ padding: '8px 12px', border: '1px solid #ccc', fontWeight: 'bold' }}>54.3%</td>
            </tr>
          </tbody>
        </table>
        <br />
        *Performance is based on Ace suggested Minimum Order Point SKUs
      </div>

      <div className={styles.sectionTitle}>Goal</div>

      <div className={styles.sectionContent}>MOP% Acceptance is &gt;80%</div>

      <div className={styles.sectionTitle}>Learn More</div>

      <div className={styles.sectionContent}>
       
        For additional guidance, review the Ace Way of Retailing Best Practice on{' '}
        <a
          href="https://acenet.aceservices.com/awor/ordering/minimum-order-points"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          Minimum Order Point
        </a>
      </div>
    </div>
  );
};

/**
 * MOPCTakeAction - Take Action drawer content for MOPC
 */
const MOPCTakeAction: React.FC = () => (
  <KpiFocusArea
    kpiCodes={['MOPC']}
    gridName="MOP Acceptance"
    cardName="FocusArea"
    automationLinks={[
      { label: 'Ace Minimum Order Points', urlCode: 'MOPC', urlField: 'automationurl' },
      { label: 'Mango Report Reductions', urlCode: 'MRED', urlField: 'automationurl' },
    ]}
  />
);

MOPC.title = 'Minimum Order Points';
MOPC.kpiHyperlink = 'dynamicURL:ACENET:description';
MOPC.actionTitle = 'Review & Update Min Order Points';
MOPC.actionContent = MOPCTakeAction;
MOPC.actionDrawerWidth = 1010;
export default MOPC;
